'use strict';
module.exports = {
    ApiBaseUrl: 'https://demo.amplofly-aws.com/public/',
    laravelBaseUrl:'https://demo.amplofly-aws.com/public/api/',
    cacheType: 'sessionStorage',
    debug:false
};